import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { UnBrandingModel } from '../models/unbranding.model';
import { ValidationModel } from '../models/validation.model';
import { tap } from 'rxjs/operators';
import { InfraService } from './infra.service';

@Injectable({
  providedIn: 'root'
})
export class ValidationsService {
  private configUrl: string;
  private configunbrandUrl: string;
  private configAPICoreUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
    //if (localStorage.getItem('selectedregion') == '1') {
    //  this.configUrl = environment.apiUrl + 'featuresvalidation';
    //  this.configunbrandUrl = environment.apiUrl + 'featuresunbranding';
    //  this.configAPICoreUrl = environment.coreUrl;
    //}
    //else {
    //  this.configUrl = environment.apiUrlRow + 'featuresvalidation';
    //  this.configunbrandUrl = environment.apiUrlRow + 'featuresunbranding';
    //  this.configAPICoreUrl = environment.coreRowUrl;
    //}
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'featuresvalidation';
      this.configunbrandUrl = data.WebEndPoint1 + 'featuresunbranding';
      this.configAPICoreUrl = data.WebEndPoint2
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public getFeaturesValidation(engagementId: number): Observable<ValidationModel[]> {
    return this.http.get<ValidationModel[]>(`${this.configUrl}/${engagementId}`);
    // .catch(this.handleError);
  }

  public getFeaturesUnbranding(engagementId: number): Observable<UnBrandingModel[]> {
    return this.http.get<UnBrandingModel[]>(`${this.configunbrandUrl}/${engagementId}`);
    // .catch(this.handleError);
  }

  public createEngagementFeaturesValidation(formulaValidation: any) {
    return this.http.post(`${this.configUrl}`, formulaValidation);
  }

  public createEngagementFeaturesUnbranding(unBranding: any) {
    return this.http.post(`${this.configunbrandUrl}`, unBranding);
  }
  public processUnbrandingfile(engagementId: any) {
    var unbrandingUrl = this.configAPICoreUrl + 'Databook/Unbranding';
    return this.http.get(`${unbrandingUrl}/${engagementId}`);
  }
  public processFormulaValidations(engagementId: any) {
    return this.http.get(`${this.configAPICoreUrl + 'formulavalidation'}/${engagementId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }
}
